(() => {
    function getParam(k) {
        try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; }
    }
    const raw = getParam('name') || getParam('utm_fn') || getParam('utm_name');
    if (!raw) return;
    const name = decodeURIComponent(raw).trim().split(/\s+/)
        .map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
        .join(' ');
    document.querySelectorAll('[data-quiz-greeting]').forEach(el => {
        el.textContent = 'Hi ' + name + ',';
        el.removeAttribute('aria-hidden');
    });
    document.querySelectorAll('[data-quiz-protocol-name-line]').forEach(el => {
        el.textContent = name + '\u2019s Ritual Protocol';
    });
})();
